import CopyButton from '@/components/buttons/CopyButton';
import Iconify from '@/components/iconify';
import { useNotify } from '@/components/snackbar';
import { SCOPES } from '@/consts/scopos';
import McpConnectionGuide from '@/sections/@public/mcp/McpConnectionGuide';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Checkbox,
    Dialog,
    Divider,
    IconButton,
    Stack,
    Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import CaktoApiWarningCopykeys from './CaktoApiWarningCopykeys';

CaktoApiCreateApikeyConfirmationDialog.propTypes = {
    apiKeyInfo: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        scope: PropTypes.string,
        client_id: PropTypes.string,
        secret_last_digits: PropTypes.string,
        createdAt: PropTypes.string,
        updatedAt: PropTypes.string,
        client_secret: PropTypes.string,
    }),
}

export default function CaktoApiCreateApikeyConfirmationDialog({ apiKeyInfo }) {

    const [open, setOpen] = useState(false)
    const notify = useNotify()

    const handleCloseDialog = () => {
        setOpen(false)
    }

    // O segredo só existe neste instante (a listagem devolve `secret_last_digits`), então o
    // clique fora, que num formulário quer dizer "deixa para lá", aqui seria perda: ele avisa em
    // vez de fechar. O Esc é gesto deliberado e fecha, como o X.
    const handleDialogClose = (event, reason) => {
        if (reason === 'backdropClick') {
            notify.warning('Copie e salve as chaves antes de fechar: elas não serão exibidas de novo.', {
                subtitle: 'Para fechar, use o X ou a tecla Esc.',
                preventDuplicate: true,
            })
            return
        }
        handleCloseDialog()
    }

    useEffect(() => {
        if (apiKeyInfo) {
            setOpen(true)
        }
    }, [apiKeyInfo])


    const selectedScopes = SCOPES.filter(scope => apiKeyInfo.scope.includes(scope.name));

    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={handleDialogClose}>
            <Stack sx={{ bgcolor: 'background.default' }} p={3} gap={3}>
                <Stack gap={2} >
                    <Box display='flex' justifyContent='space-between' alignItems='center'  >
                        <Typography variant="h4">Criar Chave API</Typography>
                        <IconButton onClick={handleCloseDialog} >
                            <Iconify icon="eva:close-fill" />
                        </IconButton>
                    </Box>

                    <Divider />

                </Stack>

                <CaktoApiWarningCopykeys />
                <Stack>
                    <Typography variant="subtitle1" color='success.main' fontSize={14} sx={{ textTransform: 'uppercase' }} >Descrição</Typography>
                    <Typography variant="body2" className='break-words' color='text.secondary'>{apiKeyInfo.name}</Typography>
                </Stack>


                <Stack>
                    <Typography variant="subtitle1" color='success.main' fontSize={14} sx={{ textTransform: 'uppercase' }} >ESCOPOS SELECIONADOS</Typography>
                    <Stack sx={{ marginLeft: -1, }} >

                        {selectedScopes.map((scope) => (
                            <Box key={scope.name} display='flex' alignItems='center' gap={1} >
                                <Checkbox
                                    size='small'
                                    checked
                                />
                                <Typography variant='body2'>{scope.label}</Typography>
                            </Box>
                        ))}

                    </Stack>
                </Stack>

                <Stack gap={1} >
                    <Typography variant="subtitle1" color='success.main' fontSize={14} sx={{ textTransform: 'uppercase' }} >CLIENT ID</Typography>
                    <Box sx={{ border: '1px solid', borderRadius: 1, borderColor: 'border.default', padding: 1, display: 'flex', justifyContent: 'space-between', gap: 2, alignItems: 'center' }} >
                        <Typography variant="body2" sx={{ wordBreak: 'break-word' }} >{apiKeyInfo.client_id}</Typography>
                        <CopyButton textToCopy={apiKeyInfo.client_id} />
                    </Box>
                </Stack>


                <Stack gap={1} >
                    <Typography variant="subtitle1" color='success.main' fontSize={14} sx={{ textTransform: 'uppercase' }} >CLIENT SECRET</Typography>
                    <Box sx={{ border: '1px solid', borderRadius: 1, borderColor: 'border.default', padding: 1, display: 'flex', justifyContent: 'space-between', gap: 2, alignItems: 'center' }} >
                        <Typography variant="body2" sx={{ wordBreak: 'break-word' }} >{apiKeyInfo.client_secret}</Typography>
                        <CopyButton textToCopy={apiKeyInfo.client_secret} />
                    </Box>
                </Stack>

                {/*
                  Este diálogo é o único lugar do produto em que client_id e
                  client_secret coexistem — a listagem de chaves só devolve
                  `secret_last_digits`. Por isso o snippet do CaktoMCP sai
                  daqui completo, pronto para colar; em qualquer outro lugar
                  o segredo teria de ser um placeholder. Fechado por padrão
                  para não competir com o aviso de copiar as credenciais.
                */}
                <Accordion disableGutters sx={{ bgcolor: 'transparent', '&:before': { display: 'none' } }}>
                    <AccordionSummary expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />} sx={{ px: 1 }}>
                        <Typography variant="subtitle1" color='success.main' fontSize={14} sx={{ textTransform: 'uppercase' }} >
                            Conectar ao CaktoMCP
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ px: 1 }}>
                        <McpConnectionGuide
                            clientId={apiKeyInfo.client_id}
                            clientSecret={apiKeyInfo.client_secret}
                            hideSecretNotice
                            compact
                        />
                    </AccordionDetails>
                </Accordion>
            </Stack>
        </Dialog>
    )
}